import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let changeStageId = useDataChange({
    context: 'selected',
    path: 'stage_id',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    changeStageId(value)
  }
}
